import { LookupByKeysRequestType } from '@unifyapps/network/generated/models/lookupByKeysRequestType';
import type { LookupRequest } from '@unifyapps/network/generated/models/lookupRequest';
import { EntityTypeVsAssetClass } from '../../consts/permissions';
import type { FeatureFlags } from './types';

export const ENV_VARIABLE_IDS = [
  'enable_save_and_close',
  // 'HIDE_AUTOMATION_TEMPLATES',
  'fetch_runs_from_connected_env',
  'enable_import_export_changeset',
  'enable_automation_documentation',
  'disable_knowledge_reporting',
  'default_sensitive_value',
  'INTERFACE_COLLABORATION',
  'enable_ai_create_interface',
  'enable_text_to_interface_code',
  'enable_text_to_code_org_only',
  'enable_ai_create_workflow',
  'enable_ai_create_agent',
  'enable_ai_fde',
  'enable_cm_variable_editor',
  'enable_support_portal',
] as const;

export const DEFAULT_TRUE_VARIABLES = ['enable_cm_variable_editor'];

// needed in case n/w request fails because of perms issue or service down
export const FALLBACK_FEATURE_FLAGS = ENV_VARIABLE_IDS.reduce((acc, key) => {
  acc[key] = false;
  // we want to enable the cm variable editor by default for now
  if (DEFAULT_TRUE_VARIABLES.includes(key)) {
    acc[key] = true;
  }
  return acc;
}, {} as FeatureFlags);

export const ENV_VARIABLE_LOOKUP_REQUEST = {
  lookupType: EntityTypeVsAssetClass.EnvironmentVariables,
  type: LookupByKeysRequestType.ByKeys,
  keys: ENV_VARIABLE_IDS,
  options: { entityType: EntityTypeVsAssetClass.EnvironmentVariables },
} as LookupRequest;
